export const quickSearchDataAutomation = {
    modal: "quick-search-modal",
    searchBar: "quick-search-bar",
    botStrip: "quick-search-bot-strip",
    searchBarText: "quick-search-bar-text",
    searchBarShortCut: "quick-search-bar-shortcut",
    searchBarLock: "quick-search-bar-lock",
    popupTab: (tab: string) => `quick-search-modal-tab-${tab}`,
    popupTabContent: (tab: string) => `quick-search-modal-tab-${tab}-content`,
    allTabPanel: "quick-search-all-tab-panel",
    allTabWebsitesToggle: "quick-search-all-tab-websites-toggle",
    allTabKeywordsToggle: "quick-search-all-tab-keywords-toggle",
    allTabReportsToggle: "quick-search-all-tab-reports-toggle",
    reportsTabList: "quick-search-reports-tab-list",
    reportsTabSearchToggle: "quick-search-reports-tab-search-toggle",
    tabEmptyDefault: "quick-search-tab-empty",
    tabEmptyLighthouse: "quick-search-tab-empty-lighthouse",
    tabEmptyAll: "quick-search-tab-empty-all",
    tabEmptyWebsite: "quick-search-tab-empty-website",
    tabEmptyKeyword: "quick-search-tab-empty-keyword",
    tabEmptyReports: "quick-search-tab-empty-reports",
    allTabPanelSection: (section: string) => `quick-search-tab-all-${section}`,
    reportRowReportsTab: (index: number) => `quick-search-reports-tab-row-${index}`,
    reportRowReportsTabSummarySearch: (index: number) => `quick-search-reports-tab-summary-row-${index}`,
    reportRowAllTab: (index: number) => `quick-search-all-tab-report-row-${index}`,
    reportRowAllTabSummarySearch: (index: number) => `quick-search-all-tab-report-summary-row-${index}`,
};
